import MediaUnits from '~/services/content/media_units';

export const media = () => {
    return {
        media_id: null,
        id: null,
        org_id: null,
        template_id: null,
        approval_flow_id: null,
        active_cost_split_id: null,
        name: null,
        printer: null,
        status: null,
        re_create: null,
        allow_access: null,
        allow_comarketer_access: null,
        allow_new_user: null,
        auto_archive: null,
        allow_new_user_connections: null,
        org_cost_share_percent: null,
        org_cost_share_user_id: null,
        file_path: null,
        media_type_id: null,
        expires_in_days: null,
        description: null,
        org_ref_number: null,
        expiration_date: null,
        video_link: null,
        video_embed_link: null,
        video_title: null,
        video_description: null,
        social_media_post_message: null,
        social_media_networks: [],
        external_content_url: null,
        download_link_text: null,
        hosted_download_content: null,
        auto_pay_org_share: null,
        social_user_website: null,
        social_user_website_editable: null,
        social_media_post_message_editable: null,
        allowed_comarketers: [],
        content_id: null,
        is_a_clone: null,
        type_link_text: null,
        export_data: null,
        permit_grant_access: null,
        html: null,
        type_id: null,
        system_name: null,
        is_snailmail: null,
        is_email: null,
        is_pdf: null,
        is_jpg: null,
        is_downloadable: null,
        is_website: null,
        is_comarketable: null,
        is_lo_team: null,
        is_editable: null,
        is_base: null,
        is_orderable: null,
        image_width: null,
        image_height: null,
        pdf_generator_id: null,
        png_generator_id: null,
        owner_org_id: null,
        group_name: null,
        group_label: null,
        group_image: null,
        remove_group_image: null,
        pricing_engine_id: null,
        properties: null,
        created_at: null,
        is_user_created: null,
        created_by: null,
        last_modified_at: null,
        last_modified_by: null,
        max_loan_products: null,
        is_custom_ad_placement: null,
        custom_preview_image: null,
        preview_image_url: null,
        markup_image_url: null,
        has_preview: null,
        updated_at: null,
        media_category: 1,
        folders: [],
        tags: [],
        print_settings: {},
        dimensions: {
            unit: MediaUnits.MILLIMETERS,
            units: [],
            bleeds: [],
            formatted: []
        }
    }
};

export const state = () => {
    return {
        isLoading: false,
        totalTypeCount: 0,
        layoutType: null,
        tags: [],
        folders: [],
        types: [],
        activeTags: [],
        activeFolders: [],
        media: media(),
        // keep latest saved representation of the media settings, so we can check for changes.
        initMedia: media()
    }
};

